import { ErrorBoundaryProps } from "components/error-boundaries/ErrorBoundaryProps";
import Generic404Error from "components/error-boundaries/Generic404Error";

const Custom404Page = ({ onReset }: ErrorBoundaryProps) => {
  return <Generic404Error onReset={onReset} />;
};

export default Custom404Page;
